import { ReduxUtils } from '../../../dependencies';
import { types } from '../../actions';

const actionTypes = {
    REQUEST: types.DELETE_COMPANY_REQUEST,
    SUCCESS: types.DELETE_COMPANY_SUCCESS,
    FAILURE: types.DELETE_COMPANY_FAILURE,
    CANCEL: types.DELETE_COMPANY_CANCEL,
};

const basicReducer = ReduxUtils.basicApiReducer({
    actionTypes,
});

export default ReduxUtils.containerReducer({
    childReducer: basicReducer,
    actionTypes: Object.values(actionTypes),
    selectors: {
        itemId: action => action.meta.id,
    },
});
